import { isEmpty } from 'ramda'
import { useLoggedUser } from '@btime/react-session'
import React from 'react'

import { useCloseModal, useIsModalFocused, useIsModalOpen, useIsOutsideModal } from './ModalsContext'
import Modal from '../structure/Modal'
import ModalsNavigation from './ModalsNavigation'

const ControlledModal = ({ children, name, showHistoryWithOnlyOne, disableHistory, publicModal, ...props }) => {
  const open = useIsModalOpen(name)
  const isFocused = useIsModalFocused(name)
  const isOutsideModal = useIsOutsideModal(name)
  const onClose = useCloseModal()

  const user = useLoggedUser()
  if ((!user || isEmpty(user)) && !publicModal) return false

  return (
    <Modal
      open={open}
      onClose={isFocused ? onClose : undefined}
      rawContent={!disableHistory && !isOutsideModal && <ModalsNavigation showFirst={showHistoryWithOnlyOne} />}
      {...props}
    >
      {children}
    </Modal>
  )
}

export default ControlledModal
